import { render, staticRenderFns } from "./PokemonLogo.vue?vue&type=template&id=08bf5552&scoped=true&"
import script from "./PokemonLogo.vue?vue&type=script&lang=js&"
export * from "./PokemonLogo.vue?vue&type=script&lang=js&"
import style0 from "./PokemonLogo.vue?vue&type=style&index=0&id=08bf5552&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bf5552",
  null
  
)

export default component.exports